<template>
  <div class="div01">
    <PwdBox v-if="bbPwd" :f1_action="savePwd"/>
    <div class="div01_1">
      <p style="color:aliceblue;font-size:9mm;">
        {{ $keys().sysname }}
      </p>
      <div class="div01_2">
        <p :style="[{color:bbCust?'cadetblue':''}]">
          欢迎使用
        </p>
        <p>
          <input v-model="userNo" class="ipt01" type="text" placeholder="账号">
        </p>
        <p>
          <input v-model="userPwd" class="ipt01" type="password" placeholder="密码" @focus="toPwd" @keydown="doLogin">
        </p>
        <p>
          {{ errMsg }}
        </p>
        <br>
        <p>
          <i v-if="bbLogin" class="el-icon-loading" style="font-size:25px;color:blue;margin: 20px 125px;"/>
          <input v-if="!bbLogin" type="button" value="登录" class="btnLogin" @click="toLogin">
        </p>
      </div>
    </div>

    <div class="divBtm">
      {{ $keys().copyright }}
    </div>
  </div>
</template>

<script>
import PwdBox from '../comps/c3_tools/04_pwd.vue'
export default {
  components: {
    PwdBox
  },
  data() {
    return {
      bbCust: true,
      bbLogin: false,
      bbPwd: false,
      userNo: '',
      userPwd: '',
      errMsg: '',
      keepwd: false,
      testInfo: {}
    }
  },
  created: function() {
    const url = window.location.href
    if (url.indexOf('/mm') > -1) {
      this.bbCust = false
    }
  },
  methods: {
    prt(a, b) {
      // console.log(`p01_login.${a}`, b)
    },
    toLogin() {
      this.bbLogin = true
      const dt = new Date()
      const user = {
        fpwd: this.comm.toAsc(this.userPwd),
        fcode: this.userNo,
        iAct: this.bbCust ? 103 : 102
      }
      this.$iPost(`/login/a`, user).then(
        rs => {
          console.log('p01.login.rs:', rs)
          if (rs && rs.status === 200 && (rs.data.stat || rs.data.token)) {
            localStorage.setItem('token', rs.data.data.token)
            const dtcnt = this.dtUtil.dtDiff(rs.data.data.menus[0].fdtpwd, dt, 'dd')
            console.log('p01.login.dtcnt:', dtcnt)
            if (dtcnt > 30) {
              // 密码过期
              alert('您的密码已过30天有效期，请更新密码')
              setTimeout(() => {
                this.bbPwd = true
              }, 100)
            } else {
              let menus
              let menu1
              let token
              if (rs.data.data && rs.data.data.menus) { // equip
                menus = rs.data.data.menus
                menu1 = rs.data.data.menus[0]
                token = rs.data.data.token
              } else { // ws
                menus = rs.data.menus
                menu1 = rs.data.menus[0]
                token = rs.data.token
              }
              localStorage.setItem('userNm', menu1.fcode)
              localStorage.setItem('token', token)
              localStorage.setItem('userCompany', menu1.fcompany)
              localStorage.setItem('bbCust', this.bbCust)

              if (!this.bbCust) {
                localStorage.setItem('userClient', menu1.fcompanyclient)
                localStorage.setItem('userPhone', menu1.fcompanyphone)
                localStorage.setItem('userAddress', menu1.fcompanyaddress)
              }
              this.initMenu(menus)

              this.bbLogin = false
              this.$router.replace({
                path: '/p02_hi',
                query: { }
              })
            }
          } else {
            this.bbLogin = false
            this.errMsg = '验证不通过'
          }
        }
      ).catch(
        rs => {
          this.bbLogin = false
          this.prt('login error:', rs)
        }
      )
    },
    toPwd() {
      this.userPwd = ''
    },
    initMenu(menus) {
      this.prt('initMenu.1.', menus)
      const array = []
      menus.forEach(row => {
        row['fidmenu'] = this.comm.toNum(row['fidmenu'])
        row['fidparent'] = this.comm.toNum(row['fidparent'])
        if (row.fidparent === 0) {
          row['fopen'] = false
          array.push(row)
        }
      })
      menus.forEach(row => {
        if (row.fidparent > 0) {
          array.forEach(row2 => {
            if (row2.fidmenu === row.fidparent) {
              if (row2.fchildren) {
                row2.fchildren.push(row)
              } else {
                row2['fchildren'] = [row]
              }
            }
          })
        }
      })/**/
      this.prt('initMenu.9', menus)
      this.comm.putDbData('menus', menus)
    },
    savePwd(pwd1, pwd2) {
      if (!pwd1) {
        this.bbPwd = false
        return
      }
      const param = {
        fcode: this.comm.toAsc(pwd2),
        fpwd: this.comm.toAsc(pwd1),
        iAct: this.bbCust ? 8 : 7
      }
      this.$iPost('/login/upPwd', param).then(
        rs => {
          console.log('upPwd:', rs)
          if (rs.data.stat && rs.data.data[0].fid !== '0') {
            // this.bbPwd = false
            // this.toLogin()
            window.location.reload()
          } else {
            alert('修改不成功')
          }
        }
      ).catch(
        rs => {
          this.bbLogin = false
          alert('修改不成功:' + rs)
        }
      )
    },
    doLogin(iKey) {
      if (iKey.keyCode === 13) this.toLogin()
    }
  }
}
</script>
<style scoped>
.div01{
  color:cadetblue ;
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('../../static/bg001.jpg');
  background-position:center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  /*
  background-color: orange;
  background-image: linear-gradient(rgb(244, 245, 245),white,rgb(244, 245, 245));
  background-image: linear-gradient(rgb(227, 237, 255),rgb(250, 252, 255),rgb(205, 226, 255));
  */
}
.div01_1{
  position: relative;
  width: 90%;
  padding: 10%  10% 0 0;
  text-align: right;
  color: aliceblue;
  height: auto;
  float: right;
  /*background-image: url('../../static/erp01.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%; */
}
.div01_2{
  position: relative;
  margin-top: 1cm;
  float: right;
  padding: 2% 0;
  height: 260px;
  width: /**280px */320px;
  border-radius: 3px;
  background-color: whitesmoke;
  /**left: 15%; */
}
.div01_2 p,h3{
  width: 320px;
  color:rgb(72, 73, 87);
  font-size: 4mm;
  margin-top: 2%;
  text-align: center;
}
.ipt01{
  width: 220px;
  height: 26px;
  margin: 5px 0;
  font-size: 4mm;
  padding: 5px;
  text-align: center;
}
.btnLogin{
  width: 200px;
  height: 46px;
  margin: 5px 0;
  font-size: 4mm;
  background-color: rgb(45, 118, 177);
  color: white;
  border: 0;
  border-radius: 2px;
}
.btnLogin :hover{
  color: azure;
  font-weight: bolder;
}

</style>



// WEBPACK FOOTER //
// src/pages/p01_login.vue